import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from '@material-ui/core/IconButton';
import { DeleteOutline } from '@material-ui/icons';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  deleteButton: {
    margin: 'auto',
  },
  background: {
    // backgroundColor: theme.palette.facet.accentRed3,
  },
  deleteIcon: {
    color: theme.palette.facet.red,
  },
});

const DeleteButtonWithConfirmation = ({
  className,
  classes,
  onDelete,
  dialogProps,
  showBackground,
  ...rest
}) => {
  const {
    title,
    message,
    cancelLabel,
    confirmLabel,
    closeOnSubmit,
  } = dialogProps;

  const onRemove = async () => {
    onDelete();
  };

  const {
    dialogOpen,
    loading,
    handleClose,
    handleSubmit,
    handleOpen,
  } = useConfirmationDialogState({
    onSubmit: onRemove,
    closeOnSubmit,
  });

  const canDelete = !!onDelete;

  if (!canDelete) return null;

  return (
    <div className={classNames(classes.root, className)}>
      <IconButton
        className={classNames(classes.deleteButton, {
          [classes.background]: showBackground,
        })}
        onClick={e => {
          e.stopPropagation();
          handleOpen(e);
        }}
        onMouseDown={e => { e.stopPropagation(); }}
        size={'small'}
        color="error"
        {...rest}
      >
        <DeleteOutline className={classes.deleteIcon} />
      </IconButton>
      {dialogOpen && (
      <NewDialog
        onClick={e => { e.stopPropagation(); }}
        onMouseDown={e => { e.stopPropagation(); }}
        title={title}
        message={message}
        cancelLabel={cancelLabel}
        confirmLabel={confirmLabel}
        confirmButtonType="error"
        loading={loading}
        onConfirm={handleSubmit}
        onCancel={() => {
          handleClose();
        }}
        onClose={() => {
          handleClose();
        }}
        showCloseIcon={false}
      />
      )}
    </div>
  );
};

DeleteButtonWithConfirmation.defaultProps = {
  className: '',
  dialogProps: {},
  showBackground: true,
};

DeleteButtonWithConfirmation.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  dialogProps: PropTypes.object,
  showBackground: PropTypes.bool,
};

export default withStyles(styles)(DeleteButtonWithConfirmation);
